var map = {
	"./calendar.html": 5,
	"./calendarDayView.html": 6,
	"./calendarHourList.html": 7,
	"./calendarMonthCell.html": 8,
	"./calendarMonthCellEvents.html": 9,
	"./calendarMonthView.html": 10,
	"./calendarSlideBox.html": 11,
	"./calendarWeekView.html": 12,
	"./calendarYearView.html": 13
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;



/*****************
 ** WEBPACK FOOTER
 ** ./src/templates nonrecursive \.html
 ** module id = 42
 ** module chunks = 0
 **/